import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { PublisherCollectingSocietyListStore } from "../../store/PublisherCollectingSocietyListStore";

type PublisherCollectingSocietyListDialogsProps = {
  store: PublisherCollectingSocietyListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de PublisherCollectingSociety.
 * Separado para mantener PublisherCollectingSocietyListPage más limpio.
 */
export const PublisherCollectingSocietyListDialogs: React.FC<PublisherCollectingSocietyListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
